export default __webpack_public_path__ + "static/media/bombIconChristmas.6abd7ac6.png";